export default __webpack_public_path__ + "static/image2-5c7e7c734261a1bffaee86f0d71d7b70.gif";